export const createValidation = (
  input: string,
  regex: RegExp,
  includesMessage: string | undefined,
  excludesMessage: string | undefined,
) => (regex.test(input) ? [] : [includesMessage, excludesMessage]);

export const IS_ALPHA_NUMERIC = /^[a-zA-Z0-9]*$/;
export const IS_ALPHA_NUMERIC_INCLUDES = 'Can only include alphanumeric characters (a-z A-Z 0-9)';
export const IS_ALPHA_NUMERIC_EXCLUDES = 'Cannot include spaces or special characters';

export const IS_ALPHA_NUMERIC_DASHES = /^[a-zA-Z0-9-]*$/;
export const IS_ALPHA_NUMERIC_DASHES_INCLUDES = `${IS_ALPHA_NUMERIC_INCLUDES} and dashes`;
export const IS_ALPHA_NUMERIC_DASHES_EXCLUDES = `${IS_ALPHA_NUMERIC_EXCLUDES} other than dashes`;

export const IS_ALPHA_NUMERIC_DASHES_SPACES = /^[a-zA-Z0-9- ]*$/;
export const IS_ALPHA_NUMERIC_DASHES_SPACES_INCLUDES = `${IS_ALPHA_NUMERIC_INCLUDES} dashes and spaces`;
export const IS_ALPHA_NUMERIC_DASHES_SPACES_EXCLUDES = `Cannot include special characters`;

export const IS_ALPHA_NUMERIC_DASHES_PERIOD = /^[a-zA-Z0-9-.]*$/;
export const IS_ALPHA_NUMERIC_DASHES_PERIOD_INCLUDES = `${IS_ALPHA_NUMERIC_INCLUDES}, dashes, and periods.`;
export const IS_ALPHA_NUMERIC_DASHES_PERIOD_EXCLUDES = `Cannot include underscores, spaces, or special characters`;

export const IS_ALPHA_NUMERIC_PERIOD_UNDERSCORE = /^[a-zA-Z0-9._]*$/;
export const IS_ALPHA_NUMERIC_PERIOD_UNDERSCORE_INCLUDES = `${IS_ALPHA_NUMERIC_INCLUDES}, periods, and underscores.`;
export const IS_ALPHA_NUMERIC_PERIOD_UNDERSCORE_EXCLUDES = `Cannot include dashes, spaces, or special characters`;

export const IS_ALPHA_NUMERIC_SPACES = /^[a-zA-Z0-9 ]*$/;
export const IS_ALPHA_NUMERIC_SPACES_INCLUDES = `${IS_ALPHA_NUMERIC_INCLUDES} and spaces`;
export const IS_ALPHA_NUMERIC_SPACES_EXCLUDES = `Cannot include special characters`;

export const IS_VALID_EMAIL = /\S+@\S+\.\S+/;
export const IS_VALID_EMAIL_INCLUDES = undefined;
export const IS_VALID_EMAIL_EXCLUDES = 'Needs to be a valid email adddress';

export const HANDLEBAR_START = /^.*{{[{]?(.*?)$/;
export const HANDLEBAR_END = /^(.*?)[}]?}}.*$/;
export const CONTAINS_VALID_HANDLEBAR = /^.*{{[{]?(.*?)[}]?}}.*$/;
export const IS_VALID_HANDLEBAR = /^{{[{]?(.*?)[}]?}}$/;
export const IS_VALID_HANDLEBAR_INCLUDES = undefined;
export const IS_VALID_HANDLEBAR_EXCLUDES = 'Needs to be a valid handlebar';

export const HAS_PROTOCOL = /^http(s)?:\/\/.*/;
export const IS_HTTP_PROTOCOL = /(http:\/\/).*/;
export const IS_HTTPS_PROTOCOL = /(https:\/\/).*/;
export const IS_VALID_URL = /^http(s)?:\/\/?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/;
export const IS_VALID_URL_INCLUDES = undefined;
export const IS_VALID_URL_EXCLUDES = 'Needs to be a valid url';

// eslint-disable-next-line no-useless-escape
export const IS_VALID_URL_WITH_HANDLEBARS =
  /^http(s)?:\/\/?[\w.-]+(?:\.[\w.-]+)+([\w\-._~:\/?#[\]@!$&'()*+,;=.]|({{[{]?(.*?)[}]?}}))+$/;

export const IS_VALID_URL_WITH_HANDLEBARS_ANYWHERE =
  /^http(s)?:\/\/?(({{[{]?(.*?)[}]?}})|[\w.-])+(?:\.[\w.-]+)+([\w\-._~:/?#[\]@!$&'()*+,;=.]|({{[{]?(.*?)[}]?}}))+$/;

// eslint-disable-next-line no-useless-escape
export const IS_VALID_HTTPS_URL_WITH_HANDLEBARS =
  /^https:\/\/[\w.-]+(?:\.[\w.-]+)+([\w\-._~:\/?#[\]@!$&'()*+,;=.]|({{[{]?(.*?)[}]?}}))+$/;
export const IS_VALID_URL_WITH_HANDLEBARS_INCLUDES = IS_VALID_URL_INCLUDES;
export const IS_VALID_URL_WITH_HANDLEBARS_EXCLUDES = IS_VALID_URL_EXCLUDES;

export const NO_SPACES = /^\S*$/;
export const NO_SPACES_INCLUDES = undefined;
export const NO_SPACES_EXCLUDES = 'Cannot include spaces';

export const NO_LEADING_SPACES_EXCLUDES = `Cannot have leading spaces`;
export const NO_TRAILING_SPACES_EXCLUDES = `Cannot have trailing spaces`;

// checks for [1-plus-of-any-non-white-space-characters.1-plus-of-any-non-white-space-characters]
export const IS_VALID_LINK = /\S+\.\S+/;
export const IS_VALID_LINK_INCLUDES = undefined;
export const IS_VALID_LINK_EXCLUDES = 'Needs to be a valid url';

// Regex to validate links with various protocols (including non-http protocols supported by our SDK, e.g. action://dismiss)
export const IS_VALID_HTML_LINK = /<a\s.*:\/\/+[^>]+>(?:[\s\S](?!<\/a>))*.<\/a>/g;
export const IS_VALID_HTML_HANDLEBARS = /href="{{.*}}"/g;
export const IS_VALID_REL_LINK = /<a\s.*href=('|")(.){0,2}\/.*('|")>.*<\/a>/g;
export const IS_VALID_HTML_HOSTED_UNSUBSCRIBE_URL = /{{\s?hostedUnsubscribeUrl\s?}}[^?]/g;
export const IS_VALID_ITERABLE_SDK_PROTOCOL = /(action|iterable):\/\/.+/;
